<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Scrolling Contents",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
         return {
            title: "Scrolling Contents",
            items: [
               {
                  text: "Scrolling Contents",
                  active: true,
               },                   
            ],

            max_date: today_str,
            from_date: today_str,
            to_date: today_str,

            scrollcontents: [],
            scrollcontent: {
               id: null,
               type: "",
               title: "",
               clinic_id : "",
               content: "",
               for:1,
               ad_type: "",
               expiry: "",
               agency: "",
               doctor_id: "",
               slot: "",
            },

            clinics: [],
            doctors: [],
            clinic_lists: [],
            doctor_lists: [],
            pharmacy_lists: [],
            lab_lists: [],
            agencies: [],
            users:"",
            content: "",
            doctor_keyword:"",
            clinic_tv: [],
            scrollTv: [],
            tv_id: "",
            doctors_tv: [],
            pharmacy_tv:[],
            pharmacies:[],
            lab_tv:[],
            labs:[],
            modal_title: "Add Content",
            button_title: "Save",
            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,         
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},

            image: "",
            preview_image: "",
            
            loading: false,
         };
      },
      mounted() {
         this.clearLocalStorage();
      },
      created() {
         this.fetchContents();
         this.fetchClinics(1);
         this.fetchDoctors();
         this.fetchAgencies();
         this.fetchPharmacies();
         this.fetchLabs();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         fetchClinics(type) {
            let url = "api/admin/tv_show/getTvClinics?type=" + type;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.clinic_lists = responseData.clinics;
               })
               .catch((err) => console.log(err));
         },
         fetchDoctors() {
               let url = "api/admin/tv_show/getTvDoctors";         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.doctor_lists = responseData.doctors;
                  })
                  .catch((err) => console.log(err));
         },

           fetchPharmacies() {
            let url = "api/admin/pharmacy/getTvPharmacies";        
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.pharmacy_lists = responseData.pharmacies;
               })
               .catch((err) => console.log(err));
         },

         fetchLabs() {
            let url = "api/admin/lab/getTvLabs";        
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.lab_lists = responseData.labs;
               })
               .catch((err) => console.log(err));
         },
         removeClinic(index) {
            this.clinics.splice(index, 1);
         },

         fetchAgencies() {
               let url = "api/admin/getAgencies";         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.agencies = responseData.agencies;
                  })
                  .catch((err) => console.log(err));
         },

         fetchClinicTv() {
               let url = "api/admin/clinicTV?clinic_id=" + this.scrollcontent.clinic_id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.clinic_tv = responseData.clinic_tv;
                  })
                  .catch((err) => console.log(err));
         },

         fetchDoctorTv() {
               let url = "api/admin/doctorTV?doctor_id=" + this.scrollcontent.doctor_id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.doctors_tv = responseData.doctors_tv;
                  })
                  .catch((err) => console.log(err));
         },

         fetchPharmacyTv() {
               let url = "api/admin/pharmacyTV?pharmacy_id=" + this.scrollcontent.pharmacy_id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.pharmacy_tv = responseData.pharmacy_tv;
                  })
                  .catch((err) => console.log(err));
         },

         fetchLabTv() {
               let url = "api/admin/labTV?lab_id=" + this.scrollcontent.lab_id;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.lab_tv = responseData.lab_tv;
                  })
                  .catch((err) => console.log(err));
         },

         fetchContents(page_url = null) {

            this.getToken();
            let url = "api/admin/get_scrolling_content?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.scrollcontents = responseData.scrolling_contents.data;
                  
                  this.pagination = responseData.scrolling_contents.links;
                  this.from = responseData.scrolling_contents.from;
                  this.to = responseData.scrolling_contents.to;
                  this.total = responseData.scrolling_contents.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

      
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         viewContent(content) {
            this.content = content.content;
            this.showModal("content-modal");
         },

         // editContent(content) {      
         //    this.fetchClinics(2);
         //    this.modal_title = "Edit Content";
         //    this.button_title = "Update";
         //    this.scrollcontent.id = content.id;
         //    this.scrollcontent.type = content.type;
         //    this.scrollcontent.clinic_id = content.clinic_id;  
         //    this.scrollcontent.title = content.title;
         //    this.scrollcontent.content = content.content;
         //    this.edit = true;
         //    this.showModal("scrollcontent-modal");
         // },

         clearForm() {          
            this.modal_title = "Add Content";
            this.button_title = "Add";
            this.scrollcontent.id = "";
            this.scrollcontent.type = "";
            this.scrollcontent.for = 1;
            this.scrollcontent.title = "";
            this.scrollcontent.content = "";
            this.scrollcontent.ad_type = "";
            this.scrollcontent.expiry = "";
            this.scrollcontent.slot = "";
            this.scrollcontent.agency = "";
            this.scrollcontent.clinic_id = "";
            this.scrollcontent.doctor_id = "";
            this.scrollcontent.lab_id = "";
            this.scrollcontent.pharmacy_id = "";
            this.image = "";
            this.preview_image = ""; 
            this.edit = false;

            this.errors = {};
            this.clinics = [];
            this.scrollTv = [];
            this.clinic_tv = [];
            this.doctors_tv = [];
            this.lab_tv = [];
            this.pharmacy_tv = [];
            this.tv_id = "";
         },

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         addContent() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "api/admin/addScroll";
               this.active_page_url = null;

            } else {
               url = "api/admin/scrolling_content/edit";
               formData.append("scrolling_content_id", this.scrollcontent.id); 
            }         

            formData.append("ad_type", this.scrollcontent.ad_type); 
            
           
            formData.append("type", this.scrollcontent.type); 
         
            if(this.scrollcontent.ad_type == 1) {
               formData.append("content", this.scrollcontent.content);  
               // formData.append("title", this.scrollcontent.title); 
            } else {
               formData.append("image", this.image); 
               formData.append("slot", this.scrollcontent.slot); 
               formData.append("agency_id", this.scrollcontent.agency); 
               formData.append("validity", this.scrollcontent.expiry);
               formData.append("title", this.scrollcontent.title); 

            }
            if(this.scrollcontent.type == 2) {
               formData.append('users', JSON.stringify(this.clinics));
            } if(this.scrollcontent.type == 4){
               formData.append('users', JSON.stringify(this.doctors));
            }
            if(this.scrollcontent.type == 5) {
               formData.append('clinic_id', JSON.stringify(this.scrollcontent.clinic_id));
               formData.append('tv_id', JSON.stringify(this.scrollTv));
            } 
            if(this.scrollcontent.type == 6){
               formData.append('doctor_id', JSON.stringify(this.scrollcontent.doctor_id));
               formData.append('tv_id', JSON.stringify(this.scrollTv));
            }if(this.scrollcontent.type == 8){
               formData.append('users', JSON.stringify(this.pharmacies));
            } if(this.scrollcontent.type == 9) {
               formData.append('pharmacy_id', JSON.stringify(this.scrollcontent.pharmacy_id));
               formData.append('tv_id', JSON.stringify(this.scrollTv));
            } 
            if(this.scrollcontent.type == 11){
               formData.append('users', JSON.stringify(this.labs));
            } if(this.scrollcontent.type == 12) {
               formData.append('lab_id', JSON.stringify(this.scrollcontent.lab_id));
               formData.append('tv_id', JSON.stringify(this.scrollTv));
            } 
         
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('scrollcontent-modal');
                  this.fetchContents(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         activateContent(content) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this Content?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.content_status.id = content.id;
                  this.content_status.status = 1;
                  this.updateContentStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateContent(content) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this Content?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.content_status.id = content.id;
                  this.content_status.status = 2;
                  this.updateContentStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateContentStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };     

            var data = JSON.stringify({
               "id": this.content_status.id,
               "status": this.content_status.status
            });

            let url = "api/admin/content/status";
            this.$axios
               .put(url, data, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchContents(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },

         addDoctor() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let doctor_id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.doctors.some(function(doctor) {
               return index === doctor.id;
            });

            if(!exists) {
               this.doctors.push({ id: index , title: text , doctor_id: doctor_id});
              }
              console.log(this.doctors);
            this.doctor = '';
         },

         addClinic() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let clinic_id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.clinics.some(function(clinic) {
               return index === clinic.id;
            });

            if(!exists) {
               this.clinics.push({ id: index , title: text ,clinic_id: clinic_id});
              }
            this.clinic = '';
         },

           addPharmacy() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let pharmacy_id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.pharmacies.some(function(pharmacy) {
               return index === pharmacy.id;
            });

            if(!exists) {
               this.pharmacies.push({ id: index , title: text ,pharmacy_id: pharmacy_id});
              }
            this.pharmacy = '';
         },

          addLab() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let lab_id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.labs.some(function(lab) {
               return index === lab.id;
            });

            if(!exists) {
               this.labs.push({ id: index , title: text ,lab_id: lab_id});
              }
            this.lab = '';
         },

         addTv() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let tvId = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.scrollTv.some(function(tv) {
               return index === tv.id;
            });

            if(!exists) {
               this.scrollTv.push({id: index , title: text, tv_id: tvId});
              }
            this.tv = '';
         },

         removeTv(index) {
            this.scrollTv.splice(index, 1);
         },

         deleteContent(scrollcontent_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this scroll content?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                  console.log(this.token);
                  let formData = new FormData();
                  formData.append("scrolling_content_id", scrollcontent_id); 

                  let url = "api/admin/scrolling_content/delete";
                  this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchContents(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.scrollcontent-modal variant="primary" class="float-end" @click="fetchClinics(1)">Add Content</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchContents()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchContents()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th width="3%">Sl No</th>
                              <th width="10%">Image Name</th>
                              <th width="10%">Agency</th>
                              <th width="5%">For</th>
                              <th width="10%">Clinic</th>
                              <th width="10%">Doctor</th>
                              <th width="10%">Pharmacy</th>  
                              <th width="10%">Lab</th>  
                              <th width="10%">Content</th>
                              <th width="10%">Image</th>
                              <th width="10%">Slot & Expired On</th>   
                              <th width="10%">Created on & Created By</th>
                              <th width="8%">Options</th>                                 
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(scrollcontents.length)">
                           <tr v-for="(content, index) in scrollcontents" :key="content.id">
                              <td>{{index + from}}</td>
                              <td>
                                 <span v-if="content.title">{{content.title}}</span>
                              </td>
                              <td>{{content.agency_name}}</td>
                              <td>
                                 <span v-if="content.type==1">All Clinics</span>
                                 <span v-if="content.type==2">Multiple Clinics</span>
                                 <span v-if="content.type==3">All Doctors</span>
                                 <span v-if="content.type==4">Multiple Doctors</span>
                                 <span v-if="content.type==5">Specific Clinic</span>
                                 <span v-if="content.type==6">Specific Doctor</span>
                                 <span v-if="content.type==7">All Pharmacies</span>
                                 <span v-if="content.type==8">Multiple Pharmacies</span>
                                 <span v-if="content.type==9">Specific Pharmacy</span>
                                  <span v-if="content.type==10">All Labs</span>
                                 <span v-if="content.type==11">Multiple Labs</span>
                                 <span v-if="content.type==12">Specific Lab</span>

                              </td>
                              <td>
                                 <span v-if="content.clinic_id">{{content.clinic_name}}</span>
                              </td>
                              <td>
                                 <span v-if="content.doctor_id">{{content.doctor_name}}</span>
                              </td>
                               <td>
                                 <span v-if="content.pharmacy_id">{{content.pharmacy_name}}</span>
                              </td>
                               <td>
                                 <span v-if="content.lab_id">{{content.lab_name}}</span>
                              </td>
                              <td>
                                 <span v-if="content.content">{{content.content | excerpt(50)}}
                                    <br><a href="#" @click.prevent="viewContent(content)" >Read More</a>
                                 </span>
                              </td>
                              <td>
                                 <img v-if="content.image" :src="$image_url + content.image" style="width:100px;" alt="image">
                              </td>
                              <td>{{content.slot}} slots<br>{{content.validity | formatDate}}</td>
                              <td>{{content.created_at | formatDateTime}}<br>
                                 <span v-if="content.added_by==1">Admin</span><span v-else>{{content.clinic_name}}</span></td>
                              <td>
                                 <!-- <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editContent(content)">Edit</b-button> -->
                                 
                                 <button class="btn btn-danger btn-sm mb-2" type="button" @click="deleteContent(content.id)">Delete</button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No scrolling contents found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(scrollcontents.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchContents(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <!-- <b-modal ref="scrollcontent-modal" id="scrollcontent-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addContent()">                        
                        <div class="row"> 

                           <b-col md="12" class="form-group">
                              <label class="control-label">Title <span class="text-danger">*</span></label>
                              <b-form-input v-model="scrollcontent.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }"></b-form-input>
                              <div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="scrollcontent.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }" @change="scrollcontent.clinic_id=''">
                                 <div class="form-check-inline">
                                    <b-form-radio name="type"  :value="1">All Clinics</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio name="type" :value="2">Specific Clinic</b-form-radio>
                                 </div>
                              </b-form-radio-group>

                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="12" class="form-group" v-if="scrollcontent.type==2">
                              <label class="control-label">Clinic <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="scrollcontent.clinic_id" v-bind:class="{ 'is-invalid': Boolean(errors.clinic_id) }">
                                 <option v-if="!scrollcontent.clinic_id" value="">Select Clinic</option>
                                 <option :value="clinic.id" v-for="clinic in clinics" :key="clinic.id">{{clinic.name}}</option>
                              </select>
                              <div v-for="(val, index) in errors.clinic_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Content <span class="text-danger">*</span></label>
                              <b-form-textarea rows="5" v-model="scrollcontent.content" v-bind:class="{ 'is-invalid': Boolean(errors.content) }"></b-form-textarea>
                              <div v-for="(val, index) in errors.content" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                              <b-button class="" variant="light" @click="hideModal('scrollcontent-modal')">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal> -->
                  <!---- modal ends ----->
                  <b-modal ref="scrollcontent-modal" id="scrollcontent-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form  @submit.prevent="addContent()">                        
                        <div class="row"> 
                           <b-col md="12" class="form-group">
                              <label class="control-label">Scrolling Type<span class="text-danger">*</span></label>
                              <select class="form-control" v-model="scrollcontent.ad_type" v-bind:class="{ 'is-invalid': Boolean(errors.ad_type) }">
                                 <option value="">Select</option>
                                 <option value="1">Content</option>
                                 <option value="2">Image</option>
                              </select>
                              <div v-for="(val, index) in errors.ad_type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.ad_type == 2">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Agency <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="scrollcontent.agency" v-bind:class="{ 'is-invalid': Boolean(errors.agency_id) }" >
                                          <option value="">Select</option>
                                          <option :value="agency.id" v-for="agency in agencies" :key="agency.id"> {{agency.name}}</option>
                                       </select> 
                                       <div v-for="(val, index) in errors.agency_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group"  v-if="scrollcontent.ad_type==2">
                              <label class="control-label">Image Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="scrollcontent.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }"></b-form-input>
                              <div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.ad_type == 2">
                              <label class="control-label">Slot<span class="text-danger">*</span></label>
                              <b-form-input type="text" v-model="scrollcontent.slot" v-bind:class="{ 'is-invalid': Boolean(errors.slot) }"></b-form-input>
                              <div v-for="(val, index) in errors.slot" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <label class="control-label">Show for <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="scrollcontent.for" v-bind:class="{ 'is-invalid': Boolean(errors.for) }">
                                 <!-- <option value="">Select</option> -->
                                 <option value="1">Doctors</option>
                                 <option value="2">Clinics</option>
                                 <option value="3">Pharmacies</option>
                                 <option value="4">Labs</option>
                              </select>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.ad_type == 2">
                              <label class="control-label">Expiry Date <span class="text-danger">*</span></label>
                              <b-form-input type="date" v-model="scrollcontent.expiry" :min="from_date" v-bind:class="{ 'is-invalid': Boolean(errors.validity) }"></b-form-input>
                              <div v-for="(val, index) in errors.validity" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.for==1">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="scrollcontent.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <div class="form-check-inline">
                                    <b-form-radio   :value="3">All Doctors</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio  :value="4">Multiple Doctors</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio  :value="6">Single Doctor</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="12" class="form-group" v-if="scrollcontent.type==4 && scrollcontent.for==1">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Doctors <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="this.users" @change="addDoctor()" v-bind:class="{ 'is-invalid': Boolean(errors.users) }" >
                                          <option value="">Select</option>
                                          <option :value="doctor_list.id" v-for="doctor_list in doctor_lists" :key="doctor_list.id"> {{doctor_list.prefix}} {{ doctor_list.name }}</option>
                                       </select> 

                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(doctor, index) in doctors" :key="index">
                                             <p>{{ doctor.title }}<span @click="removeShow(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>
                           <b-col md="12" class="form-group" v-if="scrollcontent.type==6 && scrollcontent.for==1">
                              <div class="row">
                                 <div class="form-group col-12"> 
                                    <label class="control-label">Doctors <span class="text-danger">*</span></label>
                                    <select class="form-control" v-model="scrollcontent.doctor_id" @change="fetchDoctorTv()" v-bind:class="{ 'is-invalid': Boolean(errors.doctor_id) }" >
                                       <option value="">Select</option>
                                       <option :value="doctor_list.id" v-for="doctor_list in doctor_lists" :key="doctor_list.id"> {{doctor_list.prefix}} {{ doctor_list.name }}</option>
                                    </select> 

                                 </div>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="Boolean(doctors_tv.length) && scrollcontent.for==1">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">TV <span class="text-danger">*</span></label>
                                       <select class="form-control"  @change="addTv()" v-model="this.tv_id" v-bind:class="{ 'is-invalid': Boolean(errors.tv_id) }" >
                                          <option value="">Select</option>
                                          <option :value="tv.id" v-for="tv in doctors_tv" :key="tv.id"> {{ tv.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(tv, index) in scrollTv" :key="index">
                                             <p>{{ tv.title }}<span @click="removeTv(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.for==2">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="scrollcontent.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type"  :value="1">All Clinics</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="2">Multiple Clinics</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="5">Single Clinic</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.type==2 && scrollcontent.for==2">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Clinics <span class="text-danger">*</span></label>
                                       <select class="form-control"  @change="addClinic()" v-model="this.users" v-bind:class="{ 'is-invalid': Boolean(errors.users) }" >
                                          <option value="">Select</option>
                                          <option :value="clinic_list.id" v-for="clinic_list in clinic_lists" :key="clinic_list.id"> {{ clinic_list.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(clinic, index) in clinics" :key="index">
                                             <p>{{ clinic.title }}<span @click="removeClinic(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>
                           <b-col md="12" class="form-group" v-if="scrollcontent.type==5 && scrollcontent.for==2">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Clinic <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="scrollcontent.clinic_id" @change="fetchClinicTv()" v-bind:class="{ 'is-invalid': Boolean(errors.clinic_id) }">
                                          <option value="">Select Clinic</option>
                                          <option :value="clinic.id" v-for="clinic in clinic_lists" :key="clinic.id">{{clinic.name}}</option>
                                       </select>
                                       <div v-for="(val, index) in errors.clinic_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                       
                                    </div>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="Boolean(clinic_tv.length) && scrollcontent.for==2">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">TV <span class="text-danger">*</span></label>
                                       <select class="form-control"  @change="addTv()" v-model="this.tv_id" v-bind:class="{ 'is-invalid': Boolean(errors.tv_id) }" >
                                          <option value="">Select</option>
                                          <option :value="tv.id" v-for="tv in clinic_tv" :key="tv.id"> {{ tv.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(tv, index) in scrollTv" :key="index">
                                             <p>{{ tv.title }}<span @click="removeTv(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.for==3">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="scrollcontent.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type"  :value="7">All Pharmacies</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="8">Multiple Pharmacies</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="9">Single Pharmacy</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.type==8 && scrollcontent.for==3">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Pharmacies <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="this.users" @change="addPharmacy()" v-bind:class="{ 'is-invalid': Boolean(errors.users) }" >
                                          <option value="">Select</option>
                                          <option :value="pharmacy_list.id" v-for="pharmacy_list in pharmacy_lists" :key="pharmacy_list.id"> {{ pharmacy_list.name }}</option>
                                       </select> 

                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(pharmacy, index) in pharmacies" :key="index">
                                             <p>{{ pharmacy.title }}<span @click="removeShow(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.type==9 && scrollcontent.for==3">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Pharmacy <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="scrollcontent.pharmacy_id" @change="fetchPharmacyTv()" v-bind:class="{ 'is-invalid': Boolean(errors.pharmacy_id) }">
                                          <option value="">Select Pharmacy</option>
                                          <option :value="pharmacy.id" v-for="pharmacy in pharmacy_lists" :key="pharmacy.id">{{pharmacy.name}}</option>
                                       </select>
                                       <div v-for="(val, index) in errors.pharmacy_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                       
                                    </div>
                              </div>
                           </b-col>

                       <b-col md="12" class="form-group" v-if="Boolean(pharmacy_tv.length) && scrollcontent.for==3">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">TV <span class="text-danger">*</span></label>
                                       <select class="form-control"  @change="addTv()" v-model="this.tv_id" v-bind:class="{ 'is-invalid': Boolean(errors.tv_id) }" >
                                          <option value="">Select</option>
                                          <option :value="tv.id" v-for="tv in pharmacy_tv" :key="tv.id"> {{ tv.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(tv, index) in scrollTv" :key="index">
                                             <p>{{ tv.title }}<span @click="removeTv(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.for==4">
                              <label class="control-label">Type <span class="text-danger">*</span></label>
                              <b-form-radio-group v-model="scrollcontent.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type"  :value="10">All Labs</b-form-radio> 
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="11">Multiple Labs</b-form-radio>
                                 </div>
                                 <div class="form-check-inline">
                                    <b-form-radio :name="type" :value="12">Single Lab</b-form-radio>
                                 </div>
                              </b-form-radio-group>
                              <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                             <b-col md="12" class="form-group" v-if="scrollcontent.type==11 && scrollcontent.for==4">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Labs <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="this.users" @change="addLab()" v-bind:class="{ 'is-invalid': Boolean(errors.users) }" >
                                          <option value="">Select</option>
                                          <option :value="lab_list.id" v-for="lab_list in lab_lists" :key="lab_list.id"> {{ lab_list.name }}</option>
                                       </select> 

                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(lab, index) in labs" :key="index">
                                             <p>{{ lab.title }}<span @click="removeShow(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>
                             <b-col md="12" class="form-group" v-if="scrollcontent.type==12 && scrollcontent.for==4">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">Lab <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="scrollcontent.lab_id" @change="fetchLabTv()" v-bind:class="{ 'is-invalid': Boolean(errors.lab_id) }">
                                          <option value="">Select Lab</option>
                                          <option :value="lab.id" v-for="lab in lab_lists" :key="lab.id">{{lab.name}}</option>
                                       </select>
                                       <div v-for="(val, index) in errors.lab_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                       
                                    </div>
                              </div>
                           </b-col>

                              <b-col md="12" class="form-group" v-if="Boolean(lab_tv.length) && scrollcontent.for==4">
                              <div class="row">
                                    <div class="form-group col-12"> 
                                       <label class="control-label">TV <span class="text-danger">*</span></label>
                                       <select class="form-control"  @change="addTv()" v-model="this.tv_id" v-bind:class="{ 'is-invalid': Boolean(errors.tv_id) }" >
                                          <option value="">Select</option>
                                          <option :value="tv.id" v-for="tv in lab_tv" :key="tv.id"> {{ tv.name }}</option>
                                       </select> 
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(tv, index) in scrollTv" :key="index">
                                             <p>{{ tv.title }}<span @click="removeTv(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>

                              </div>
                           </b-col>
                           <!-- <b-col md="12" class="form-group" v-if="!edit">
                              <label class="control-label">Video <span class="text-danger">*</span></label>
                              <input type="file" @change="setFile($event)" accept=".mp4" class="form-control" :class="{ 'is-invalid': Boolean(errors.video) }">

                              <div v-for="(val, index) in errors.video" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col> -->
                           <b-col md="12" class="form-group" v-if="scrollcontent.ad_type==1">
                              <label class="control-label">Content <span class="text-danger">*</span></label>
                              <b-form-textarea rows="5" v-model="scrollcontent.content" v-bind:class="{ 'is-invalid': Boolean(errors.content) }"></b-form-textarea>
                              <div v-for="(val, index) in errors.content" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.ad_type==2">
                              <label class="control-label">Image <span class="text-danger">*</span></label>
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg,.gif" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }">
                              <img v-if="preview_image" class="mt-2" :src="preview_image" style="max-width: 200px;">
                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                                 <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                 {{ loading ? 'Saving...' : button_title }}
                              </b-button>
                              <b-button class="" variant="light" @click="hideModal('scrollcontent-modal')" :disabled="loading">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>

                  <!---- modal starts ---->
                  <b-modal ref="content-modal" id="content-modal" title="View Content" hide-footer @hidden="clearForm()">
                     <b-form>
                        
                        <b-col md="12">
                           <card class="p-3">
                              <p>{{content}}</p>
                           </card>
                        </b-col>                   
                        
                        <b-col md="12">                           
                           <b-button class="" variant="light" @click="$bvModal.hide('content-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
